import { CHECKBOX_COLUMN_PADDING } from '@components/ListV2/components/table/virtualizedTable.styles';
import { WORKSPACE_PADDING } from '@components/v2/constants';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { teceoGrayBackground, teceoGrayPrimary } from '../../../Theme';
import { TECEO_MAX_WIDTH } from '../../../utils/constants';

interface IOrderEditPageStylesProps {
  isSuggested?: boolean;
  isKeyboardOpen?: boolean;
  workspacePadding?: number;
  isDetailsOpen?: boolean;
}

export const ORDER_SECTION_DIVIDER_COLOR = 'rgba(0, 0, 0, 0.10)';

const useOrderEditPageStyles = makeStyles<IOrderEditPageStylesProps>()((theme: Theme, props) => ({
  rootDiv: {
    boxSizing: 'border-box',
    position: 'relative',
    maxWidth: TECEO_MAX_WIDTH,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    width: '100%',
  },

  linearProgress: {
    top: 0,
  },

  root: {
    width: '100%',
    [theme.breakpoints.down('sm')]: { paddingBottom: theme.spacing(14) },
    [theme.breakpoints.up('sm')]: { paddingBottom: theme.spacing(24) },
  },

  pageHeaderContainer: {
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(10),
    },
    [theme.breakpoints.only('sm')]: {
      height: theme.spacing(8.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(12.5),
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  headerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: 'transparent',

    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(6),
      backgroundColor: 'transparent',
    },
  },

  editSections: {
    [theme.breakpoints.down('sm')]: {
      position: 'sticky',
      top: theme.spacing(7),
      zIndex: 3,
      height: theme.spacing(6.5),
      backgroundColor: teceoGrayBackground,
    },
  },

  sectionPaper: {
    border: `0.5px solid ${ORDER_SECTION_DIVIDER_COLOR}`,
  },

  offlineAlert: {
    paddingBottom: '12px',
    [theme.breakpoints.only('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(3),
    },
  },

  mainPageContentBox: {
    [theme.breakpoints.only('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(3),
    },
  },
  customMargin: {
    marginBottom: theme.spacing(1.5),
  },

  summaryRoot: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: props.isSuggested ? theme.palette.secondary.light : teceoGrayPrimary,
    zIndex: 10,
    color: props.isSuggested ? theme.palette.text.primary : theme.palette.common.white,
    width: 'auto',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: props.isKeyboardOpen ? 'none' : 'flex',
    borderTop: props.isSuggested ? `1px solid ${theme.palette.custom.border.secondary}` : undefined,
    borderRadius: theme.shape.borderRadiusLg,
    paddingTop: theme.spacing(0.75),
    paddingLeft: theme.spacing(
      (props.workspacePadding ?? WORKSPACE_PADDING) + CHECKBOX_COLUMN_PADDING,
    ),
    paddingRight: theme.spacing(props.workspacePadding ?? WORKSPACE_PADDING),
    paddingBottom: theme.spacing(0.75),
    marginRight: props.isDetailsOpen
      ? 0
      : theme.spacing(props.workspacePadding ?? WORKSPACE_PADDING),
  },

  divider: {
    backgroundColor: ORDER_SECTION_DIVIDER_COLOR,
    height: 0.5,
  },
}));

export default useOrderEditPageStyles;
